@if(data.method == 'logout'){
<div class="{{ 'dialog ' + data.type }} ">
  <!-- <img src="{{ data.icon }}" height="{{ data.height }}" /> -->

  <div class="actions">
    <span class="logout-msg"> Logging out in </span>
  </div>
  <div class="timer-div">
    <span class="timer">{{ countdown }}</span>
  </div>

  <div class="access-denied-error-text">
    <span>
      You will be logging out of <b>SPARCi</b> and this window will be closed
    </span>
  </div>
</div>
} @else if(data.method == 'redirect'){
  <div class="{{ 'dialog ' + data.type }} ">
  <img src="{{ data.icon }}" style="height:75px" />
  <div class="access-denied-error-text">
    {{ data.message }}
  </div>
  <div class="actions">
    <span style="margin-top:10px; color: black">
      Redirecting to Veeva Claims in
      <span style="font-size: 21px; color: red">{{
        countdown
      }}</span>
      ...
    </span>
  </div>
</div>
}
